import { IconListSearch } from '@tabler/icons';

// constant
const icons = {
    IconListSearch
};

// ==============================|| DASHBOARD PAGE & MENU ITEMS ||============================== //

const maintenance = {
    id: 'maintenance',
    type: 'group',
    children: [
        {
            id: 'logs',
            title: 'LOGS',
            type: 'item',
            url: '/logs',
            icon: icons.IconListSearch,
            breadcrumbs: false
        }
    ]
};

export default maintenance;
